// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"a154a3ea","477":"08d88e7a","597":"b0b49f46","742":"152a638d","764":"aa5d8624","855":"152a638d"}[chunkId] + ".chunk.css";
};